import React from "react";

import PalamSensorDock from "../../../../generic/palam_sensor_dock";


const HoverOverlay = props => {
    let { 
      //onStartMoveWidget, 
      //onDeleteWidget, 
      //onResizeWidget, 
      num_slots = 0, 
      //didDrop, 
      //acceptsDrop
    } = props;
    num_slots ++;
    let docks = [];
    for (let i = 0; i < num_slots; i++) {
      docks[i] = <PalamSensorDock size={30} label="Connect Sensor" key={i} acceptsDrop/>;
    }    
    console.log(docks)

    let innerCssClass = "widget-overlay-inner";
    return (
        <div className="widget-overlay">
          <div className={innerCssClass}>
            {docks}
          
          </div>        
        </div>
    );
  };

  export default HoverOverlay